/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Morepages1Inputs */

const he_common_morepages1 = /** @type {(inputs: Common_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עמודים נוספים`)
};

const en_common_morepages1 = /** @type {(inputs: Common_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More pages`)
};

/**
* | output |
* | --- |
* | "More pages" |
*
* @param {Common_Morepages1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const common_morepages1 = /** @type {((inputs?: Common_Morepages1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Morepages1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_morepages1(inputs)
	return en_common_morepages1(inputs)
});
export { common_morepages1 as "common_morePages" }